export default __webpack_public_path__ + "static/media/principal-banner.06a10688.png";